import React from "react";
import { BodyOneProps } from "../../models";

const requiredSymbol = () => {
  return (
    <span className="text-red-600">*</span>
  )
}

const BodyOne = ({children, isRequired,  ...restProps }: BodyOneProps) => {
  const {className, ...newProps } = {...restProps}
  return (
    <p className={`text-sm text-black text-bold font-poppins ${className}`} {...newProps}  >
      { children } { isRequired ? requiredSymbol() : '' }
    </p>
  );
};

export default BodyOne;
